module.exports = __webpack_public_path__ + "img/menu_wallet_pre.3138e9a8.svg";